export default process.env.NODE_ENV === 'development' || !process.env.NODE_ENV;